<template>
  <div class="page">
    <!-- 页面下拉刷新 -->
    <cp-page-refresh @refresh="refresh" ref="pageRefresh">
      <!-- 公共头部组件 -->
      <common-header />
      <div class="container">
        <!-- swiper新闻 -->
        <base-swiper
          v-if="bannerList.length"
          class="video-swiper"
          :list="bannerList"
          :showBottomMask="true"
          :autoplay="autoplay"
          @handle-click-slide="handleClickSlide"
        />
        <!-- 热点新闻 -->
        <hot-news v-if="fineList.length" :list="fineList" @cb-detail="cbHotDetail" />
        <!-- 新闻分类tabs -->
        <common-tabs v-if="typeList.length" :list="typeList" :canSwipeNum="4" ref="typeTabs" @change-tab="changeTab">
          <news-list :list="newsList" @cb-detail="cbHotDetail"/>
        </common-tabs>
      </div>
    </cp-page-refresh>
    <!-- 公共底部tabs -->
    <foot-table />
  </div>
</template>

<script>
import FootTable from '@/views/layout/foot-table'
import CommonHeader from '@/views/layout/common-header'
import BaseSwiper from '@/views/components/base-swiper'
import HotNews from './components/hot-news'
import CommonTabs from '@/views/components/common-tabs'
import NewsList from './components/news-list'
import { news, common } from '@/agent'
import Dict from '@/core/dict'

export default {
  components: {
    'foot-table': FootTable,
    'common-header': CommonHeader,
    'base-swiper': BaseSwiper,
    'hot-news': HotNews,
    'common-tabs': CommonTabs,
    'news-list': NewsList,
  },
  data () {
    return {
      bannerList: [], // banner列表
      fineList: [], // 头部热点新闻列表
      typeList: [], // 新闻分类列表
      newsList: [], // 分类新闻列表
      newsParam: {
        pageNum: 1,
        query: {
          typeId: ''
        }
      }, // 资讯列表请求参数
      currentIndex: 0, // 当前新闻分类swiper的列
      upFinish: false, // 是否已加载全部
      autoplay: true // 轮播自动播放
    }
  },
  mounted () {
    this.$loading.show()
    this.init()
  },
  beforeRouteLeave (to, from, next) {
    // 设置滚动条位置
    const scrollTop = Math.abs(document.querySelector('.page').getBoundingClientRect().top)
    this.$util.setTabsLeaveSite(from.path, scrollTop)
    next()
  },
  methods: {
    // 初始化
    async init () {
      await this.FindBannerListByReceive()
      this.$loading.hide()
    },
    // 下拉刷新页面
    refresh () {
      this.$refs.typeTabs.handleToIndex(0) // 设置新闻分类默认选中第一个
      Object.assign(this.$data, this.$options.data()) // 重置data的数据为初始状态
      this.$refs.pageRefresh.hideFresh() // 隐藏下拉刷新
      this.init()
    },
    // 资讯头轮播图api
    async FindBannerListByReceive () {
      const reqData = {
        query: {
          typeId: 8
        },
        pageNum: 1,
        pageSize: 10,
        sorts: [{ sortPropertyName: 'orderNbr', sortType: 'DESC' }]
      }
      const result = await common.findBannerListByReceive(reqData)
      this.bannerList = [...result.data.list]
      this.bannerList = this.bannerList.map(item => {
        // 1图片，2视频
        item.bgVideo = item.categoryType == 2 ? item.src : ''
        item.imgSrc = item.categoryType == 1 ? item.src : ''
        return item
      })
      this.autoplay = this.bannerList.length > 1
      this.FindPagePartIsFine()
    },
    // 资讯热点新闻api
    async FindPagePartIsFine () {
      const reqData = {
        query: {},
        pageNum: 1,
        pageSize: 3,
        sorts: [{ sortPropertyName: 'modifyTime', sortType: 'DESC' }]
      }
      const result = await news.findPagePartIsFine(reqData)
      this.fineList = [...result.data.list]
      this.FindNewsType()
    },
    // 资讯标题分类api
    async FindNewsType () {
      const result = await news.findNewsType()
      this.typeList = [...result.data]
      this.newsParam.query.typeId = this.typeList[this.currentIndex]['dictValue']
      this.FindPagePart()
    },
    // 分类新闻列表api；resetList重置list:[]再赋值
    async FindPagePart (resetList = false) {
      const reqData = {
        ...this.newsParam,
        pageSize: 10,
        sorts: [{ sortPropertyName: 'actualTime', sortType: 'DESC' }]
      }
      const result = await news.findPagePart(reqData)
      if (result.code === 100) {
        this.newsList = resetList
          ? result.data.list
          : [...this.newsList, ...result.data.list]
        if (this.newsParam.pageNum >= result.data.pages) {
          this.upFinish = true
        } else {
          this.newsParam.pageNum += 1
          this.upFinish = false
        }
        // this.$refs.pageScroll.hideLoading() // 底部加载loading隐藏
      }
    },
    // 上滑加载
    load () {
      this.FindPagePart()
    },
    // 点击新闻swiper
    handleClickSlide (currentIndex) {
      const item = this.bannerList[currentIndex]
      this.formatBannerRouteTarget(item)
    },
    // 点击热点新闻
    cbHotDetail (item) {
      this.formatNewsRoutrTarget(item)
    },
    // 点击新闻资讯
    cbDetail (item) {
      this.formatNewsRoutrTarget(item)
    },
    // 轮播图路由跳转处理
    formatBannerRouteTarget (item) {
      // jumpType = 1：外链；2：课程；3：详情
      if (item.jumpType === 1) {
        if (item.url) {
          this.$router.push({
            path: '/content-webview',
            query: { url: encodeURIComponent(item.url), type: Dict.linkType.iframe }
          })
        }
      } else if (item.jumpType === 2) {
        this.$router.push({
          path: '/course/detail',
          query: {
            id: item.chapterId,
            backPath: 'news',
            type: Dict.pageType.inform,
            // tabIndex: this.tabIndex
          }
        })
      } else if (item.jumpType === 3) {
        this.$router.push({
          path: '/story/detail',
          query: {
            id: item.id,
            type: Dict.pageType.advertisement // 根据类型，在详情页调不同接口
          }
        })
      }
    },
    // 新闻资讯路由跳转处理
    formatNewsRoutrTarget (item) {
      // categoryType = 1：平台;2：外链
      if (item.categoryType === 1) {
        this.$router.push({
          path: '/story/detail',
          query: {
            id: item.id,
            type: Dict.pageType.hotNews
          }
        })
      } else if (item.categoryType === 2) {
        if (item.jumpLink) {
          this.$router.push({
            path: '/content-webview',
            query: { url: encodeURIComponent(item.jumpLink), type: Dict.linkType.iframe }
          })
        }
      }
    },
    // 切换新闻分类
    changeTab (index) {
      this.currentIndex = index
      this.newsParam.pageNum = 1
      this.newsParam.query.typeId = this.typeList[index]['dictValue']
      this.FindPagePart(true)
    },
  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
}
.container {
  padding: $header-height 0 $foot-table-height;
}
.news-list {
  min-height: calc(100vh - #{$header-height} - #{$foot-table-height} - 44px);
}
</style>
